
/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
    let __root = "";
    
    if (process.env.RUNTIME_ENV === "local") {       
        __root = "http://localhost:7999";
    }

    if (process.env.RUNTIME_ENV === "development") {       
        __root = "https://api-cleaning.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "production") {       
        __root = "https://api-cleaning.m2msystems.cloud";
    }
    return __root
}

/**
 * 作業員が作業を開始する
 * 
 */
export const startOperation = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/start`;
    return __queries ? `${__path}?${__queries}` : __path;
};
startOperation.method = "POST" as const;

/**
 * 作業員が作業を終了する
 * 
 */
export const finishOperation = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/finish`;
    return __queries ? `${__path}?${__queries}` : __path;
};
finishOperation.method = "POST" as const;

/**
 * 作業員が作業を報告する
 * 
 */
export const reportOperations = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/report`;
    return __queries ? `${__path}?${__queries}` : __path;
};
reportOperations.method = "POST" as const;

/**
 * 作業員が作業を取得する
 * 
 */
export const findById = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findById.method = "GET" as const;

/**
 * 作業員が作業を取得する
 * 
 */
export const findOperationsByIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findOperationsByIds.method = "POST" as const;

/**
 * 作業員が新しいトラブルを送信する
 * 
 */
export const createTrouble = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/troubles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createTrouble.method = "POST" as const;

/**
 * 作業員がトラブル写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueOperationTroublePictureUploadUrl = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/troubles/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueOperationTroublePictureUploadUrl.method = "POST" as const;

/**
 * 作業員がアップロード済み写真を紐づけて新しいトラブルを作成する
 * 
 */
export const createOperationTroubleWithUploadedPictures = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/troubles/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createOperationTroubleWithUploadedPictures.method = "POST" as const;

/**
 * 作業員が写真ツアー動画をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issuePhotoTourMovieUploadUrl = ({operationId, photoTourItemId}: {operationId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/photoTourItemId/${photoTourItemId}/streamUpload/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issuePhotoTourMovieUploadUrl.method = "POST" as const;

/**
 * 作業員が写真ツアー動画のS3直接アップロード完了を通知する
 * 
 */
export const completePhotoTourMovieUpload = ({operationId, photoTourItemId}: {operationId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${operationId}/photoTourItemId/${photoTourItemId}/streamUpload/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completePhotoTourMovieUpload.method = "POST" as const;

/**
 * 作業員が作業員PhotoTourの回数を取得する
 * 
 */
export const operatorGetCleaningPhotoTourCounts = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operationsCounts`;
    return __queries ? `${__path}?${__queries}` : __path;
};
operatorGetCleaningPhotoTourCounts.method = "GET" as const;

/**
 * 清掃員がオペレーションの添付画像を取得する
 * 
 */
export const findOparationAttachmentImagesForCleaner = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operations/${cleaningId}/attachment_images`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findOparationAttachmentImagesForCleaner.method = "GET" as const;

/**
 * シフト(Shift)を作成する
 * 
 */
export const createShift = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/shifts`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createShift.method = "POST" as const;

/**
 * シフト(Shift)を提出する
 * 
 */
export const submitShift = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/shifts/submit`;
    return __queries ? `${__path}?${__queries}` : __path;
};
submitShift.method = "PUT" as const;

/**
 * シフトを取得する
 * 
 */
export const listShifts = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/shifts/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listShifts.method = "POST" as const;

/**
 * シフト(Shift)を更新する
 * 
 */
export const updateShift = ({shiftId}: {shiftId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/shifts/${shiftId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateShift.method = "PUT" as const;

/**
 * シフト(Shift)を削除する
 * 
 */
export const deleteShift = ({shiftId}: {shiftId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/shifts/${shiftId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteShift.method = "DELETE" as const;

/**
 * シフト(Shift)を取得する
 * 
 */
export const findShiftById = ({shiftId}: {shiftId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/shifts/${shiftId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findShiftById.method = "GET" as const;

/**
 * シフト(Shift)を未提出にする
 * 
 */
export const unsubmitShift = ({shiftId}: {shiftId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/shifts/${shiftId}/unsubmit`;
    return __queries ? `${__path}?${__queries}` : __path;
};
unsubmitShift.method = "PUT" as const;

/**
 * 清掃員が清掃の写真ツアーを取得する
 * 
 */
export const cleanerGetCleaningPhotoTourMedia = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/photo_tours/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
cleanerGetCleaningPhotoTourMedia.method = "GET" as const;

/**
 * 清掃員が、自身のパスを取得する
 * 
 */
export const listCleanerPath = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/cleaner_paths/list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleanerPath.method = "POST" as const;

/**
 * 清掃員が、清掃に基づいてBigQueryの情報を取得する
 * 
 */
export const listBigQueryInfo = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/bigquery/list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listBigQueryInfo.method = "POST" as const;

/**
 * 清掃員が、自身に紐づくお願い事の一覧を取得する
 * 
 */
export const hasErrands = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/errands`;
    return __queries ? `${__path}?${__queries}` : __path;
};
hasErrands.method = "POST" as const;

/**
 * 清掃員が自身に紐づく清掃の一覧を取得する
 * 
 */
export const listActiveOperationsForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/active`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listActiveOperationsForCleaner.method = "GET" as const;

/**
 * 清掃員が、清掃のチェックインを確認する（cleaningIds は最大10,000件）
 * 
 */
export const checkCleaningsCheckinByIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/checkin`;
    return __queries ? `${__path}?${__queries}` : __path;
};
checkCleaningsCheckinByIds.method = "POST" as const;

/**
 * 清掃員が物件または共用部の情報を取得する
 * 
 */
export const listPlacementDetailsByCleaningIdsForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/placements`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listPlacementDetailsByCleaningIdsForCleaner.method = "POST" as const;

/**
 * 清掃員がcleaningIdsからcleaningIdとPhotoTourのマップを取得する
 * 
 */
export const listPhotoToursByCleaningIdsForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/photo_tours`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listPhotoToursByCleaningIdsForCleaner.method = "POST" as const;

/**
 * 清掃員が清掃を開始できるかどうかを確認する
 * 
 */
export const isReadyToStartCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/is_ready`;
    return __queries ? `${__path}?${__queries}` : __path;
};
isReadyToStartCleaning.method = "GET" as const;

/**
 * 清掃員の単価承認リクエストを取得します
 * 
 */
export const listPendingApprovalRequests = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/approval_request/pending/list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listPendingApprovalRequests.method = "GET" as const;

/**
 * 清掃員の単価承認リクエストの個数を取得します
 * 
 */
export const countPendingApprovalRequests = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/approval_request/pending/count`;
    return __queries ? `${__path}?${__queries}` : __path;
};
countPendingApprovalRequests.method = "GET" as const;

/**
 * 清掃員の単価承認リクエストを承認します
 * 
 */
export const approvePendingApprovalRequest = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/approval_request/pending/approve`;
    return __queries ? `${__path}?${__queries}` : __path;
};
approvePendingApprovalRequest.method = "POST" as const;

/**
 * @deprecated 清掃員の単価承認リクエストを拒否します
 * 
 */
export const rejectPendingApprovalRequest = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/approval_request/pending/reject`;
    return __queries ? `${__path}?${__queries}` : __path;
};
rejectPendingApprovalRequest.method = "POST" as const;

/**
 * 清掃員の単価承認リクエスト機能が有効かどうかを確認します
 * 
 */
export const checkApprovalRequestFeatureEnabledForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/feature/approval_request/is_enabled`;
    return __queries ? `${__path}?${__queries}` : __path;
};
checkApprovalRequestFeatureEnabledForCleaner.method = "GET" as const;

/**
 * 清掃員が単価承認リクエストを1件取得します
 * 
 */
export const getApprovalRequestByIdAndMySelf = ({approvalRequestId}: {approvalRequestId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/approval_request/${approvalRequestId}/pending`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getApprovalRequestByIdAndMySelf.method = "GET" as const;

/**
 * 清掃員が今日の承認リクエストが存在するかどうかを確認する
 * 
 */
export const pendingApprovalRequestExistsToday = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/operation/pending_approval_request/exists_today`;
    return __queries ? `${__path}?${__queries}` : __path;
};
pendingApprovalRequestExistsToday.method = "GET" as const;

/**
 * 清掃員が清掃idを元に住所を取得する
 * 
 */
export const getPlacementAddressByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/placement/${cleaningId}/address`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getPlacementAddressByCleaningId.method = "GET" as const;

/**
 * @deprecated 清掃員が自身に紐づく清掃の一覧を取得する
 * 
 */
export const listMyCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listMyCleanings.method = "GET" as const;

/**
 * @deprecated 清掃員が自身に紐づく共用部清掃の一覧を取得する
 * 
 */
export const listMyCommonAreaCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/commonAreaCleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listMyCommonAreaCleanings.method = "GET" as const;

/**
 * 清掃員が物件の情報を取得する
 * 
 */
export const findListingByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/listing`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findListingByCleaningId.method = "GET" as const;

/**
 * 清掃員がリスティングに紐づくトラブルの一覧を取得する
 * 
 */
export const listTroublesByListingId = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/listings/${listingId}/troubles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listTroublesByListingId.method = "GET" as const;

/**
 * 清掃員が清掃の写真ツアーを取得する
 * 
 */
export const findPhotoTourByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/photo_tour`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTourByCleaningId.method = "GET" as const;

/**
 * 清掃員が写真ツアー画像をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issuePhotoTourImageUploadUrl = ({cleaningId, photoTourItemId}: {cleaningId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/items/${photoTourItemId}/upload/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issuePhotoTourImageUploadUrl.method = "POST" as const;

/**
 * 清掃員が写真ツアー画像のS3直接アップロード完了を通知する
 * 
 */
export const completePhotoTourImageUpload = ({cleaningId, photoTourItemId}: {cleaningId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/items/${photoTourItemId}/upload/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completePhotoTourImageUpload.method = "POST" as const;

/**
 * 清掃員が写真ツアーの写真を更新する
 * 
 */
export const photoTourImage = ({imageId}: {imageId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/photoTourImage/${imageId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
photoTourImage.method = "PUT" as const;

/**
 * 清掃員が写真ツアーの動画を更新する
 * 
 */
export const photoTourVideo = ({movieId}: {movieId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/photoTourMovie/${movieId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
photoTourVideo.method = "PUT" as const;

/**
 * 清掃員が清掃を開始する
 * 
 */
export const startCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/cleanings/${cleaningId}/start`;
    return __queries ? `${__path}?${__queries}` : __path;
};
startCleaning.method = "POST" as const;

/**
 * 清掃員が清掃を終了する
 * 
 */
export const finishCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/cleanings/${cleaningId}/finish`;
    return __queries ? `${__path}?${__queries}` : __path;
};
finishCleaning.method = "POST" as const;

/**
 * 清掃報告を完了する
 * 
 */
export const reportCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/cleanings/${cleaningId}/report`;
    return __queries ? `${__path}?${__queries}` : __path;
};
reportCleaning.method = "POST" as const;

/**
 * お願い事写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueErrandPictureUploadUrl = ({errandId}: {errandId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/errands/${errandId}/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueErrandPictureUploadUrl.method = "POST" as const;

/**
 * お願い事写真のS3直接アップロード完了を通知する
 * 
 */
export const completeErrandPictureUpload = ({errandId}: {errandId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/errands/${errandId}/picture/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeErrandPictureUpload.method = "POST" as const;

/**
 * 清掃員が清掃の詳細情報を取得する
 * 
 */
export const getCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaning.method = "GET" as const;

/**
 * 清掃員が清掃に紐付いたタスクの一覧を取得する
 * 
 */
export const listCleaningTasks = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/tasks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleaningTasks.method = "GET" as const;

/**
 * 清掃員がタスク写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueTaskPictureUploadUrl = ({cleaningId, taskId}: {cleaningId: string, taskId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/tasks/${taskId}/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueTaskPictureUploadUrl.method = "POST" as const;

/**
 * 清掃員がタスク写真のS3直接アップロード完了を通知する
 * 
 */
export const completeTaskPictureUpload = ({cleaningId, taskId}: {cleaningId: string, taskId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/tasks/${taskId}/picture/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeTaskPictureUpload.method = "POST" as const;

/**
 * 清掃員が清掃のチェックリストを取得する
 * 
 */
export const getCheckitems = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/checkitems`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCheckitems.method = "GET" as const;

/**
 * 清掃員が新しいトラブルを送信する
 * 
 */
export const sendProblems = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/troubles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
sendProblems.method = "POST" as const;

/**
 * 清掃員がトラブル写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueTroublePictureUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/troubles/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueTroublePictureUploadUrl.method = "POST" as const;

/**
 * 清掃員がアップロード済み写真を紐づけて新しいトラブルを作成する
 * 
 */
export const createTroubleWithUploadedPictures = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/troubles/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createTroubleWithUploadedPictures.method = "POST" as const;

/**
 * 清掃員が清掃証拠写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueEvidenceUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/evidence/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueEvidenceUploadUrl.method = "POST" as const;

/**
 * 清掃員が清掃証拠写真のS3直接アップロード完了を通知する
 * 
 */
export const completeEvidenceUpload = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/evidence/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeEvidenceUpload.method = "POST" as const;

/**
 * 清掃員が清掃証拠写真を削除する
 * 
 */
export const deleteEvidencePicture = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/evidence`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteEvidencePicture.method = "DELETE" as const;

/**
 * 清掃員がキーボックスの鍵番号を取得する
 * 
 */
export const getKeyboxNumber = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/keybox`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getKeyboxNumber.method = "GET" as const;

/**
 * 清掃員がキーボックス写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueKeyboxPictureUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/keybox/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueKeyboxPictureUploadUrl.method = "POST" as const;

/**
 * 清掃員がキーボックスの鍵を変更する（S3直接アップロード後の完了通知）
 * 
 */
export const completeKeyboxRotation = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/keybox/rotate/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeKeyboxRotation.method = "POST" as const;

/**
 * 清掃員がキーボックスの鍵を変更する
 * 
 */
export const rotateKeyboxNumber = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v3/mypage/cleanings/${cleaningId}/keybox/rotate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
rotateKeyboxNumber.method = "POST" as const;
export const m2mCleaning_cleanerV3 = {startOperation,finishOperation,reportOperations,findById,findOperationsByIds,createTrouble,issueOperationTroublePictureUploadUrl,createOperationTroubleWithUploadedPictures,issuePhotoTourMovieUploadUrl,completePhotoTourMovieUpload,operatorGetCleaningPhotoTourCounts,findOparationAttachmentImagesForCleaner,createShift,submitShift,listShifts,updateShift,deleteShift,findShiftById,unsubmitShift,cleanerGetCleaningPhotoTourMedia,listCleanerPath,listBigQueryInfo,hasErrands,listActiveOperationsForCleaner,checkCleaningsCheckinByIds,listPlacementDetailsByCleaningIdsForCleaner,listPhotoToursByCleaningIdsForCleaner,isReadyToStartCleaning,listPendingApprovalRequests,countPendingApprovalRequests,approvePendingApprovalRequest,rejectPendingApprovalRequest,checkApprovalRequestFeatureEnabledForCleaner,getApprovalRequestByIdAndMySelf,pendingApprovalRequestExistsToday,getPlacementAddressByCleaningId,listMyCleanings,listMyCommonAreaCleanings,findListingByCleaningId,listTroublesByListingId,findPhotoTourByCleaningId,issuePhotoTourImageUploadUrl,completePhotoTourImageUpload,photoTourImage,photoTourVideo,startCleaning,finishCleaning,reportCleaning,issueErrandPictureUploadUrl,completeErrandPictureUpload,getCleaning,listCleaningTasks,issueTaskPictureUploadUrl,completeTaskPictureUpload,getCheckitems,sendProblems,issueTroublePictureUploadUrl,createTroubleWithUploadedPictures,issueEvidenceUploadUrl,completeEvidenceUpload,deleteEvidencePicture,getKeyboxNumber,issueKeyboxPictureUploadUrl,completeKeyboxRotation,rotateKeyboxNumber};
